import React, { useState, useEffect } from "react";
import Header from "../../../commons/Header/Header";
import Sidebar from "../../../commons/Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import viewImage from "../../../assets/images/icons/view.svg";
function PayoutManagementDriver() {
  
  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Payout Management (Driver)</h3>
            </div>
            <div className="d-flex">
              <div class="mt-3">
                <Link to='/payout-management' class="btn btn-default rounded-lg">Back</Link>
              </div>
            </div>
            <div className="table-responsive px-0 mt-4">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th width="200">Driver ID</th>
                    <th width="150">Driver Name</th>
                    <th>Availability</th>
                    <th>Mobile Number</th>
                    <th>Vehicle Type</th>
                    <th>Email id</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>                      
                    <tr>
                        <td className="text-left">#2313343</td>
                        <td>John Doe</td>
                        <td>Available</td>
                        <td>+1 12345 54321</td>
                        <td>Bike</td>
                        <td>Xyz@Gmail.Com</td>
                        <td>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to='/payout-management/driver/view' className="mx-2">
                                    <img src={viewImage} alt="View" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="text-left">#2313343</td>
                        <td>John Doe</td>
                        <td>Available</td>
                        <td>+1 12345 54321</td>
                        <td>Bike</td>
                        <td>Xyz@Gmail.Com</td>
                        <td>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to='/payout-management/driver/view' className="mx-2">
                                    <img src={viewImage} alt="View" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="text-left">#2313343</td>
                        <td>John Doe</td>
                        <td>Available</td>
                        <td>+1 12345 54321</td>
                        <td>Bike</td>
                        <td>Xyz@Gmail.Com</td>
                        <td>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to='/payout-management/driver/view' className="mx-2">
                                    <img src={viewImage} alt="View" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="text-left">#2313343</td>
                        <td>John Doe</td>
                        <td>Available</td>
                        <td>+1 12345 54321</td>
                        <td>Bike</td>
                        <td>Xyz@Gmail.Com</td>
                        <td>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to='/payout-management/driver/view' className="mx-2">
                                    <img src={viewImage} alt="View" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="text-left">#2313343</td>
                        <td>John Doe</td>
                        <td>Available</td>
                        <td>+1 12345 54321</td>
                        <td>Bike</td>
                        <td>Xyz@Gmail.Com</td>
                        <td>
                            <div className="d-flex align-items-center justify-content-center">
                                <Link to='/payout-management/driver/view' className="mx-2">
                                    <img src={viewImage} alt="View" />
                                </Link>
                            </div>
                        </td>
                    </tr>
                    {/* <tr>
                      <td colSpan="6" className="text-center py-4">
                        No Data Found
                      </td>
                    </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PayoutManagementDriver;